import { useState, useEffect, useCallback, useRef } from "react";
import "./FontComponent.css";

import { useDispatch, useSelector } from "react-redux";
import { LowerCase, UpperCase, SmallCaps, UnderLine, iconOne, iconTwo, None } from "../../../../../assets/icons/index";
import { updateFontStyleState, saveFontStyle } from "../../../../../Redux/actions/projectActions";
import {
  Radio,
  Dropdown,
  ColorPicker,
  Number_point_Input,
  NumberInput_fontsize,
  Dropdown_fontFamily,
  RadioFont,
  NumberInput_pointFont,
} from "../../../../../Components";

import Dropdown_fontFamilyto from "../../../../../Components/Dropdown/Dropdown_FontFamilyto";

import { getApiFontUrl, injectFontFaceFromUrl } from "./fontFaceUtils";
import { preloadFontFamily } from "./fontLoadUtils";
import { getAvailableFontWeights } from "./fontWeightUtils";
import loaderGif from "../../../../../assets/icons/Loader/Scrollx_animate.gif";
import { scheduleProjectSave } from "../../../projectSaveCoordinator";
import DisclosureMotion from "../../OptionBlocks/DisclosureMotion";
import {
  clampFontSize,
  MAX_FONT_SIZE,
  MIN_FONT_SIZE,
} from "./fontSizeUtils";

//  font family is Archivo Narrow
const fontweightArchivo = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const laPetiteGazette = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontWeightColunaRounded = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightAll = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightNotMediumandSemiboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotMediumandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotSemoboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightShowRegularandExtrabold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotBlack = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotLight = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyRegularAndBold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightOnlyFutura = [
  { label: "Light", value: 300 },
  { label: "Regular  N/A", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyTradeGothic = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

// Default weights for custom uploaded fonts
const fontweightCustom = [
  { label: "Regular", value: 400 },
  { label: "Bold", value: 700 },
];

const initialOptions = [
  { label: "Archivo Narrow", value: "archivo narrow" },
  { label: "Barlow Condensed", value: "barlow condensed" },
  { label: "Barlow Semi Condensed", value: "barlow semi condensed" },
  { label: "Clear Sans", value: "clear sans" },
  { label: "Coluna Rounded", value: "Coluna Rounded" },
  { label: "Cooper Hewitt", value: "cooper hewitt" },
  { label: "Courier Pitch", value: "Courier pitch" },
  { label: "Futura", value: "futura" },
  { label: "Kanit", value: "kanit" },
  { label: "Karla", value: "karla" },
  { label: "La Petite Gazette", value: "la petite gazette" },
  { label: "Libre Baskerville", value: "libre baskerville" },
  { label: "Marion", value: "marion" },
  { label: "Montserrat", value: "montserrat" },
  { label: "Noto Sans", value: "noto sans" },
  { label: "Oswald", value: "oswald" },
  { label: "Poppins", value: "poppins" },
  { label: "Playfair Display", value: "playfair display" },
  { label: "Raleway", value: "raleway" },
  { label: "Roboto", value: "roboto" },
  { label: "Roboto Condensed", value: "roboto condensed" },
  { label: "Saira Condensed", value: "saira condensed" },
  { label: "Source Sans Pro", value: "source sans pro" },
  { label: "Space Mono", value: "space mono" },
  { label: "Teko", value: "teko" },
  { label: "Tiillium Webt", value: "tiillium webt" },
  { label: "Trade Gothic", value: "trade gothic" },
  { label: "Trade Gothic Condensed", value: "Trade Gothic Condensed" },
];

const FontComponent = ({
  label,
  type,
  currentOpen,
  setOpen,
  currentBlockType,
  isCard,
  pendingUploadedFont,
  onPendingUploadedFontApplied,
}) => {
  const dispatch = useDispatch();
  const s3CustomFonts = useSelector((state) => state?.project?.customFonts ?? [],);
 
  const {credits, currentBlock, _id: projectId } = useSelector((state) => state?.project ?? {});
  const currentBlockData = credits?.find((block, index) => index === currentBlock?.idx && block?._id === currentBlock?.id);
  const isDoubleColumn =  currentBlockData?.options?.double_columns === true;

  const [options, setOptions] = useState(() => initialOptions);

  const [selectedID, setSelectedID] = useState("");
  const [selectedfontWeightID, setSelectedfontWeightID] = useState("");
  const [optionsForFont, setOptionsForFont] = useState([]);

  const [isApplyingFont, setIsApplyingFont] = useState(false);

  useEffect(() => {
    if (!s3CustomFonts?.length) {
      setOptions(initialOptions);
      return;
    }
    s3CustomFonts.forEach(({ fontFamily, proxyUrl }) => {
      injectFontFaceFromUrl(fontFamily, getApiFontUrl(proxyUrl));
    });
    const s3Options = s3CustomFonts.map(({ fontFamily }) => ({
      label: `⬆ ${fontFamily}`,
      value: fontFamily,
      isCustom: true,
    }));
    setOptions([...s3Options, ...initialOptions]);
  }, [s3CustomFonts]);

  useEffect(() => {
    if (!pendingUploadedFont || currentOpen !== type) return;
    const fontExists = s3CustomFonts?.some(
      ({ fontFamily }) => fontFamily === pendingUploadedFont,
    );
    if (fontExists) {
      const fontFamily = pendingUploadedFont;
      updateFontState("fontFamily", fontFamily);
      dispatch(
        saveFontStyle(
          fontStyleTypeRef.current,
          currentBlockType,
          "fontFamily",
          fontFamily,
          null,
          isCard,
        ),
      );
      onPendingUploadedFontApplied?.();
    }
  }, [pendingUploadedFont, currentOpen, type, s3CustomFonts]);

  let fontStyleType = type;
  if (currentBlockType === "nameonly" && type === "name") {
    fontStyleType = "nameOnlyStyle";
  } else {
    fontStyleType = type;
  }

  const fontStyleTypeRef = useRef(fontStyleType);
  useEffect(() => {
    fontStyleTypeRef.current = fontStyleType;
  }, [fontStyleType]);

  let fontStyle = useSelector((state) => state?.project?.fontStyle[fontStyleType]);
  const committedFontFamilyRef = useRef(fontStyle?.fontFamily);
  const committedFontWeightRef = useRef(fontStyle?.fontWeight);
  const fontPreviewTimerRef = useRef(null);
  const fontWeightPreviewTimerRef = useRef(null);
  const isFontPreviewActiveRef = useRef(false);
  const isFontWeightPreviewActiveRef = useRef(false);
  // console.log("fontStyle", fontStyle, "currentBlockType", currentBlockType,);

  useEffect(() => {
    if (!isFontPreviewActiveRef.current) {
      committedFontFamilyRef.current = fontStyle?.fontFamily;
    }
  }, [fontStyle?.fontFamily]);

  useEffect(() => {
    if (!isFontWeightPreviewActiveRef.current) {
      committedFontWeightRef.current = fontStyle?.fontWeight;
    }
  }, [fontStyle?.fontWeight]);

  useEffect(
    () => () => {
      if (fontPreviewTimerRef.current) {
        clearTimeout(fontPreviewTimerRef.current);
      }
      if (fontWeightPreviewTimerRef.current) {
        clearTimeout(fontWeightPreviewTimerRef.current);
      }
    },
    [],
  );

  useEffect(() => {
    const idx = options.findIndex((opt) => opt.value === fontStyle?.fontFamily);
    if (idx !== -1) setSelectedID(idx);
    const id = optionsForFont.findIndex(
      (opt) => opt.value === fontStyle?.fontWeight,
    );
    if (id !== -1) setSelectedfontWeightID(id);
  }, [fontStyle, options, optionsForFont]);

  const updateFontState = (key, value) => {
    dispatch(updateFontStyleState(type, key, value, currentBlockType, true));
  };

  const clearFontPreviewTimer = useCallback(() => {
    if (!fontPreviewTimerRef.current) return;
    clearTimeout(fontPreviewTimerRef.current);
    fontPreviewTimerRef.current = null;
  }, []);

  const clearFontWeightPreviewTimer = useCallback(() => {
    if (!fontWeightPreviewTimerRef.current) return;
    clearTimeout(fontWeightPreviewTimerRef.current);
    fontWeightPreviewTimerRef.current = null;
  }, []);

  const endFontFamilyPreview = useCallback(() => {
    clearFontPreviewTimer();
    if (!isFontPreviewActiveRef.current) return;

    isFontPreviewActiveRef.current = false;
    const committedFontFamily = committedFontFamilyRef.current;
    if (!committedFontFamily) return;

    dispatch(
      updateFontStyleState(
        type,
        "fontFamily",
        committedFontFamily,
        currentBlockType,
        false,
      ),
    );
  }, [clearFontPreviewTimer, currentBlockType, dispatch, type]);

  const previewFontFamily = useCallback(
    (fontFamily) => {
      clearFontPreviewTimer();
      preloadFontFamily(fontFamily, fontStyle?.fontWeight);

      fontPreviewTimerRef.current = setTimeout(() => {
        fontPreviewTimerRef.current = null;
        const committedFontFamily = committedFontFamilyRef.current;

        if (fontFamily === committedFontFamily) {
          if (isFontPreviewActiveRef.current) {
            dispatch(
              updateFontStyleState(
                type,
                "fontFamily",
                committedFontFamily,
                currentBlockType,
                false,
              ),
            );
          }
          isFontPreviewActiveRef.current = false;
          return;
        }

        isFontPreviewActiveRef.current = true;
        dispatch(
          updateFontStyleState(
            type,
            "fontFamily",
            fontFamily,
            currentBlockType,
            false,
          ),
        );
      }, 90);
    },
    [clearFontPreviewTimer, currentBlockType, dispatch, fontStyle?.fontWeight, type],
  );

  const endFontWeightPreview = useCallback(() => {
    clearFontWeightPreviewTimer();
    if (!isFontWeightPreviewActiveRef.current) return;

    isFontWeightPreviewActiveRef.current = false;
    const committedFontWeight = committedFontWeightRef.current;
    if (committedFontWeight == null) return;

    dispatch(
      updateFontStyleState(
        type,
        "fontWeight",
        committedFontWeight,
        currentBlockType,
        false,
      ),
    );
  }, [clearFontWeightPreviewTimer, currentBlockType, dispatch, type]);

  const previewFontWeight = useCallback(
    (fontWeight) => {
      clearFontWeightPreviewTimer();
      preloadFontFamily(fontStyle?.fontFamily, fontWeight);

      fontWeightPreviewTimerRef.current = setTimeout(() => {
        fontWeightPreviewTimerRef.current = null;
        const committedFontWeight = committedFontWeightRef.current;

        if (fontWeight === committedFontWeight) {
          if (isFontWeightPreviewActiveRef.current) {
            dispatch(
              updateFontStyleState(
                type,
                "fontWeight",
                committedFontWeight,
                currentBlockType,
                false,
              ),
            );
          }
          isFontWeightPreviewActiveRef.current = false;
          return;
        }

        isFontWeightPreviewActiveRef.current = true;
        dispatch(
          updateFontStyleState(
            type,
            "fontWeight",
            fontWeight,
            currentBlockType,
            false,
          ),
        );
      }, 90);
    },
    [
      clearFontWeightPreviewTimer,
      currentBlockType,
      dispatch,
      fontStyle?.fontFamily,
      type,
    ],
  );

  const handleFontHeaderClick = () => {
    if (currentOpen === type) setOpen(null);
    else setOpen(type);
  };

  const debouncedSave = useCallback(
    (keyOrUpdates, value, targetType, delay = 1000) => {
      const saveType = targetType || fontStyleType;
      const updates =
        keyOrUpdates && typeof keyOrUpdates === "object"
          ? keyOrUpdates
          : { [keyOrUpdates]: value };
      const [primaryKey, primaryValue] = Object.entries(updates)[0] || [];
      const fontStyleSnapshot = { ...(fontStyle || {}), ...updates };
      return scheduleProjectSave(
        `font-style-debounce:${projectId}:${saveType}`,
        async () => {
          setIsApplyingFont(true);
          try {
            await dispatch(
              saveFontStyle(
                saveType,
                currentBlockType,
                primaryKey,
                primaryValue,
                null,
                isCard,
                {
                  projectId,
                  isCard,
                  fontStyle: fontStyleSnapshot,
                  optimistic: true,
                },
              ),
            );
          } finally {
            setIsApplyingFont(false);
          }
        },
        delay,
      );
    },
    [dispatch, fontStyleType, currentBlockType, isCard, projectId, fontStyle],
  );

  const commitFontFamily = useCallback(
    (fontFamily) => {
      clearFontPreviewTimer();
      isFontPreviewActiveRef.current = false;
      committedFontFamilyRef.current = fontFamily;
      preloadFontFamily(fontFamily, fontStyle?.fontWeight);
      dispatch(
        updateFontStyleState(
          type,
          "fontFamily",
          fontFamily,
          currentBlockType,
          true,
        ),
      );
      debouncedSave("fontFamily", fontFamily, null, 300);
    },
    [
      clearFontPreviewTimer,
      currentBlockType,
      debouncedSave,
      dispatch,
      fontStyle?.fontWeight,
      type,
    ],
  );

  const commitFontWeight = useCallback(
    (fontWeight) => {
      clearFontWeightPreviewTimer();
      isFontWeightPreviewActiveRef.current = false;
      committedFontWeightRef.current = fontWeight;
      dispatch(
        updateFontStyleState(
          type,
          "fontWeight",
          fontWeight,
          currentBlockType,
          true,
        ),
      );
      preloadFontFamily(fontStyle?.fontFamily, fontWeight);
      debouncedSave("fontWeight", fontWeight, null, 300);
    },
    [
      clearFontWeightPreviewTimer,
      currentBlockType,
      debouncedSave,
      dispatch,
      fontStyle?.fontFamily,
      type,
    ],
  );

  const fontWieghtHandleSet = (fontFamily) => {
    if (!fontFamily) return fontweightAll;
    const isCustom = options.find(
      (opt) => opt.value === fontFamily && opt.isCustom,
    );
    if (isCustom) return fontweightCustom;
    if (fontFamily === "archivo narrow") return fontweightArchivo;
    if (fontFamily === "la petite gazette") return laPetiteGazette;
    if (
      fontFamily === "barlow condensed" ||
      fontFamily === "barlow semi condensed" ||
      fontFamily === "noto sans" ||
      fontFamily === "montserrat" ||
      fontFamily === "raleway" ||
      fontFamily === "saira condensed" ||
      fontFamily === "kanit" ||
      fontFamily === "poppins"
    )
      return fontweightAll;
    if (fontFamily === "roboto" || fontFamily === "clear sans")
      return fontweightNotSemoboldandExtrabold;
    if (fontFamily === "roboto condensed") return fontweightAll;
    if (
      fontFamily === "libre baskerville" ||
      fontFamily === "marion" ||
      fontFamily === "Trade Gothic Condensed"
    )
      return fontweightShowRegularandExtrabold;
    if (fontFamily === "source sans pro" || fontFamily === "tiillium webt")
      return fontweightNotMediumandExtrabold;
    if (
      fontFamily === "cooper hewitt" ||
      fontFamily === "teko" ||
      fontFamily === "oswald"
    )
      return fontweightNotExtrabold;
    if (fontFamily === "karla") return fontweightNotBlack;
    if (fontFamily === "playfair display") return fontweightNotLight;
    if (fontFamily === "space mono") return fontweightOnlyRegularAndBold;
    if (fontFamily === "Coluna Rounded" || fontFamily === "Courier pitch")
      return fontWeightColunaRounded;
    if (fontFamily === "futura") return fontweightOnlyFutura;
    if (fontFamily === "trade gothic") return fontweightOnlyTradeGothic;
    return fontweightAll;
  };

  useEffect(() => {
    setOptionsForFont(
      getAvailableFontWeights(fontWieghtHandleSet(fontStyle?.fontFamily)),
    );
  }, [fontStyle?.fontFamily]);

  const isFontVisible = currentOpen === type;
  
const tooltipText = {
  Heading: "Define styling for the main section headings.",

  "Sub-Heading":
    "Define styling for the sub-headings.",

  Role:
    "Define styling for the credit role texts",

  Name:
    "Define styling for the credit name texts.",
};

  const hideFontLineHeight = [
    "role",
    "name",
    "blurb",
    "songTitle",
    "songDetails",
  ].includes(type);
  const showMarginBottom =
    label === "Heading" || label === "Sub-Heading" || label === "Song Title";

  return (
    <div  className={ !isFontVisible ? "main-div" : "main-div mt-[4px] mb-[8px] bg-[#ffffff08] rounded-xl"}>
      <div className={!isFontVisible ? "main-font" : "main-font2 border-[1px] border-[#ffffff0f] rounded-xl  margin-bottom"}>
        <div className={!isFontVisible ? "heading" : "active-heading"} onClick={handleFontHeaderClick}>
          <div className="fonts-lable flex items-center">
            {label && (
              <div className=" inline-block group font-lable  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">{label}</span>
                {tooltipText[label] && (
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    {tooltipText[label]}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className={!isFontVisible ? "heading-data" : "active_heading-data"}>
            <div className="fontHeading w-[70%] flex items-center justify-start overflow-hidden">
              <span className="truncate">{fontStyle?.fontFamily}</span>
                {isApplyingFont && (
                <img className="w-5 h-5 ml-2 object-contain" src={loaderGif} alt="applying font..."  />
              )}
            </div>
            <p className="w-[22%]  text-[#c1bad1] font-semibold fontHeading">{fontStyle?.fontSize} PX</p>
            <div className="icon-fontBox">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`icon font-disclosure-chevron${
                  isFontVisible ? " font-disclosure-chevron--open" : ""
                }`}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
          </div>
        </div>
        <DisclosureMotion
          expanded={isFontVisible}
          contentClassName="main-fontData"
          role="region"
          ariaLabel={`${label} typography settings`}
          allowOverflowWhenOpen
        >
            {/* Row 1 – Font Family + Weight */}
            <div className="main-section">
              <div className="section1">
                {/* <span className="font-img" /> */}
                <Dropdown_fontFamilyto
                  options={options}
                  value={
                    fontStyle?.fontFamily
                      ? fontStyle.fontFamily.length > 5
                        ? fontStyle.fontFamily.slice(0, 10) + "..."
                        : fontStyle.fontFamily
                      : "6646archivo narrow"
                  }
                  selectedID={selectedID}
                  onOptionIntent={(fontFamily) =>
                    preloadFontFamily(fontFamily, fontStyle?.fontWeight)
                  }
                  onOptionPreview={previewFontFamily}
                  onOptionPreviewEnd={endFontFamilyPreview}
                  onChange={commitFontFamily}
                />
              </div>
              <div className="section2">
                <Dropdown_fontFamily
                  options={optionsForFont}
                  value={fontStyle?.fontWeight}
                  selectedID={selectedfontWeightID}
                  customWidth={{ minWidth: "7.5rem" }}
                  onOptionPreview={previewFontWeight}
                  onOptionPreviewEnd={endFontWeightPreview}
                  onChange={commitFontWeight}
                />
              </div>
            </div>

            {/* Row 2 – Font Size + Transform */}
            <div className="main-section">
              <div className="section1">
                <span className=" mr-[8px] text-white text-base">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#c7c0d9"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width={20}
                    height={20}
                  >
                    <path d="M4 7V4h16v3M9 20h6M12 4v16" />
                  </svg>
                </span>
                <NumberInput_fontsize
                  step="1"
                  min={MIN_FONT_SIZE}
                  max={MAX_FONT_SIZE}
                  value={fontStyle?.fontSize}
                  onChange={(val) => {
                    const clamped = clampFontSize(val);
                    updateFontState("fontSize", clamped);
                    debouncedSave("fontSize", clamped);
                  }}
                  postLabel="px"
                  inputBox
                />
              </div>
              <div className="section2">
                <RadioFont
                  options={[
                    { icon: None, value: "none" },
                    { icon: UpperCase, value: "uppercase" },
                    { icon: SmallCaps, value: "capitalize" },
                    { icon: LowerCase, value: "lowercase" },
                    { icon: UnderLine, value: "underline" },
                  ]}
                  value={fontStyle?.textTransform}
                  onChange={(val) => {
                    const updates =
                      val === "underline"
                        ? { textDecoration: val }
                        : { textDecoration: "none", textTransform: val };
                    if (val === "underline") {
                      updateFontState("textDecoration", val);
                    } else {
                      updateFontState("textDecoration", "none");
                      updateFontState("textTransform", val);
                    }
                    debouncedSave(updates, undefined, undefined, 300);
                  }}
                  withIcon
                />
              </div>
            </div>

            {/* Row 3 – Letter Spacing + Color */}
            <div className="main-section ">
              <div className="section1">
                <img className="font-img" src={iconTwo} alt="" />
                <NumberInput_pointFont
                  step="0.1"
                  min="0.0"
                  max="4.9"
                  value={fontStyle?.letterSpacing}
                  onChange={(val) => {
                    updateFontState("letterSpacing", Number(val));
                    debouncedSave(
                      "letterSpacing",
                      parseFloat(val > -0.1 ? (val < 5.0 ? val : 0.0) : 4.9),
                    );
                  }}
                  inputBox
                />
              </div>
              <div className="section2 pr-1">
                <div className="font-text-color">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="font-img"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#c7c0d9"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width={20}
                    height={20}
                    aria-hidden="true"
                  >
                    <path d="M12 21a9 9 0 0 1 0-18c4.97 0 9 3.582 9 8 0 1.06-.474 2.078-1.318 2.828C18.838 14.578 17.693 15 16.5 15H14a2 2 0 0 0-1 3.75A1.3 1.3 0 0 1 12 21" />
                    <circle cx="7.5" cy="10.5" r="1" fill="#c7c0d9" stroke="none" />
                    <circle cx="12" cy="7.5" r="1" fill="#c7c0d9" stroke="none" />
                    <circle cx="16.5" cy="10.5" r="1" fill="#c7c0d9" stroke="none" />
                  </svg>
                  <span className=" text-white text-xs">Text Color</span>
                  <ColorPicker
                    id={`font-text-color-${type}`}
                    value={fontStyle?.color}
                    onChange={(val) => {
                      updateFontState("color", val);
                      debouncedSave("color", val);
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Row 4 – Line Height (heading / subheading) + Margin Bottom */}
            {(!hideFontLineHeight || showMarginBottom) && (
            <div className="main-section">
              <div className="section1">
                {!hideFontLineHeight && (
                  <>
                    <img className="font-img" src={iconOne} alt="" />
                    <NumberInput_pointFont
                      step="0.10"
                      min="0.80"
                      max="5.0"
                      comp="lineHeight"
                      value={fontStyle?.lineHeight}
                      onChange={(val) => {
                        const num = parseFloat(val);
                        if (isNaN(num)) return;
                        const clamped = Math.min(Math.max(num, 0.8), 5.0);
                        updateFontState("lineHeight", clamped);
                        debouncedSave("lineHeight", clamped);
                      }}
                    />
                  </>
                )}
              </div>
              <div className="section2">
                {showMarginBottom ? (
                  <div className="text-section">
                    <span
                      className="bg-gray"
                      style={{
                        color: "#fff",
                        fontSize: "18px",
                        marginRight: "8px",
                      }}
                    >
                      &darr;
                    </span>
                    <NumberInput_fontsize
                      step="1"
                      min="0"
                      max="30"
                      value={
                        fontStyle?.marginBottom ? fontStyle?.marginBottom : 0
                      }
                      onChange={(val) => {
                        updateFontState("marginBottom", Number(val));
                        debouncedSave(
                          "marginBottom",
                          parseInt(val > 0 ? (val < 100 ? val : 0) : 99),
                        );
                      }}
                      inputBox
                    />
                  </div>
                ) : null}
              </div>
            </div>
            )}
        </DisclosureMotion>
      </div>
    </div>
  );
};

export default FontComponent;
